import { NgModule } from "@angular/core";

import { SharedModule } from "../../shared/shared.module";
import { ResidentToolbarModule } from "../../patient/resident-toolbar";

import { TaskTypesComponent } from "./task-types.component";
import { TaskTypesListComponent } from "./options-list/task-types-list.component";
import { DuplicateTaskDialogComponent } from "./duplicate-task-dialog/duplicate-task-dialog.component";
import { MatDialogModule } from "@angular/material/dialog";

@NgModule({
	imports: [SharedModule, ResidentToolbarModule, MatDialogModule],
	declarations: [TaskTypesComponent, TaskTypesListComponent, DuplicateTaskDialogComponent],
	exports: [TaskTypesComponent, TaskTypesListComponent],
})
export class TaskOptionsModule {}
